<template>
  <div>
    <v-flex xs12 class="mb-5">
      <h2 class="text-center mb-3">Tilstand oppsummering og utbedringer</h2>
      <h3 class="text-center mb-3">Punkter fra tilstandsrapport</h3>
      <table v-if="stepValues.stateQuestions.length != 0">
        <thead>
          <tr>
            <th>Punkt</th>
            <th>{{ stateCommentTitle }} *</th>
            <th>{{ stateFixedBy }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in stepValues.stateQuestions">
            <tr :key="index">
              <td>{{ item.roomName }}: {{ item.title }}</td>
              <td>
                <v-text-field
                  solo
                  hide-details
                  :label="stateCommentTitle"
                  clearable
                  v-model="item.comment"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  solo
                  hide-details
                  :label="stateFixedBy"
                  clearable
                  v-model="item.fixedBy"
                ></v-text-field>
              </td>
            </tr>
            <tr :key="index + '3'">
              <td colspan="3">
                <v-divider></v-divider>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <div class="text-xs-center" v-if="stepValues.stateQuestions.length == 0">
        <v-chip color="teal" text-color="white">
          <v-avatar>
            <v-icon>mdi-check-circle</v-icon> </v-avatar
          >Alle punkter er rapportert som OK
        </v-chip>
      </div>
      <div v-if="cleaningEnabled">
        <h3 class="text-center mb-3 mt-5">Punkter fra vaskerapport</h3>
        <table v-if="stepValues.cleanQuestions.length != 0">
          <thead>
            <tr>
              <th>Punkt</th>
              <th>Kommentar *</th>
              <th>Utbedres av</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in stepValues.cleanQuestions">
              <tr :key="index">
                <td>{{ item.roomName }}: {{ item.title }}</td>
                <td>
                  <v-text-field
                    solo
                    hide-details
                    label="Kommentar"
                    clearable
                    v-model="item.comment"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    solo
                    hide-details
                    label="Utbedres av"
                    clearable
                    v-model="item.fixedBy"
                  ></v-text-field>
                </td>
              </tr>
              <tr :key="index + '3'">
                <td colspan="3">
                  <v-divider></v-divider>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <div
          class="text-xs-center"
          v-if="stepValues.cleanQuestions.length == 0"
        >
          <v-chip color="teal" text-color="white">
            <v-avatar>
              <v-icon>mdi-check-circle</v-icon> </v-avatar
            >Alle punkter er rapportert som OK
          </v-chip>
        </div>
      </div>
    </v-flex>
    <v-flex v-if="protocol.version.protocol_definition.protocol_type_id == 1">
      <v-textarea
        box
        label="Kommentarer"
        v-model="stepValues.comment"
        @input="updateFields"
      ></v-textarea>
      <v-textarea
        box
        label="Avtalte utbedringer"
        v-model="stepValues.agreements"
        @input="updateFields"
      ></v-textarea>
    </v-flex>
    <v-flex v-if="config.info">
      <span v-html="config.info" />
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
    
  </div>
</template>

<script>
import step from "../../mixins/step";
export default {
  mixins: [step],
  data() {
    return {};
  },
  computed: {
    stateCommentTitle: function () {
      if (this.config.stateCommentTitle != null && this.config.undefined) {
        return this.config.stateCommentTitle;
      }
      return "Kommentar";
    },
    stateFixedBy: function () {
      if (
        this.config.stateFixedBy != null &&
        this.config.stateFixedBy != undefined
      ) {
        return this.config.stateFixedBy;
      }
      return "Utbedres av";
    },
    finished: function () {
      let finished = true;
      this.stepValues.cleanQuestions.forEach((item) => {
        if (typeof item.comment === "undefined") {
          finished = false;
        } else {
          if (item.comment == "" || item.comment == null) {
            finished = false;
          }
        }
      });
      this.stepValues.stateQuestions.forEach((item) => {
        if (typeof item.comment === "undefined") {
          finished = false;
        } else {
          if (item.comment == "" || item.comment == null) {
            finished = false;
          }
        }
      });
      if (!finished) {
        this.$emit("error", "Alle avvik må kommenteres");
        return false;
      }
      return true;
    },
    cleaningEnabled: function () {
      if (this.stepValues.cleaningEnabled) {
        return true;
      }
      return false;
    },
  },
  methods: {
    next: function () {
      if (this.finished) {
        this.$emit("next-page");
        return true;
      } else {
        return false;
      }
    }
  },
  activated: function () {
    let stateQuestions = [];
    let cleanQuestions = [];
    let rooms = [];
    if (this.protocol.saved_values.steps.rooms.saved_values) {
      rooms = this.protocol.saved_values.steps.rooms.saved_values.roomList;
    }
    for (var i in rooms) {
      let room = rooms[i];
      for (var l in room.type.stateQuestions.questions) {
        let question = room.type.stateQuestions.questions[l];
        if (room.name != "") {
          question.roomName = "(" + room.type.name + ") " + room.name;
        } else {
          question.roomName = room.type.name;
        }

        if (question.active && question.value == 0) {
          if (
            question.needsFixing != null &&
            question.needsFixing != undefined
          ) {
            if (question.needsFixing) {
              stateQuestions.push(question);
            }
          }
        }
      }
      for (var lo in room.type.cleanQuestions.questions) {
        let question = room.type.cleanQuestions.questions[lo];
        if (room.name != "") {
          question.roomName = room.name;
        } else {
          question.roomName = room.type.name;
        }

        if (question.active && question.value == 0) {
          if (
            question.needsFixing != null &&
            question.needsFixing != undefined
          ) {
            if (question.needsFixing) {
              cleanQuestions.push(question);
            }
          }
        }
      }
    }
    this.stepValues.cleanQuestions = cleanQuestions;
    this.stepValues.stateQuestions = stateQuestions;
  },
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}
table td,
table th {
  padding: 3px;
  font-size: 1rem;
}
table tr.inactive {
  background-color: lightgrey;
}
table tr.inactive .objectTitle {
  text-decoration: line-through;
}
table .radio {
  font-size: 2rem;
}
hr {
  margin-top: 0;
  margin-bottom: 0;
}
</style>